export default __webpack_public_path__ + "static/media/flourishing_red_petal.6cc564b5.svg";